<p-dialog header="Escribe el nombre del pasajero" [(visible)]="dNewUser" [modal]="true" [closable]="false"
  class="custom-confirm">
  <div class="flex flex-column gap-3">
    <div class="flex field"><input #newusu type="text" pInputText max="40"> </div>
    <div class="flex justify-content-between">
      <button pButton pRipple type="button" label="Cancelar" class="p-button-raised p-button-danger p-button-text"
        icon="pi pi-times" (click)="closeAddUsuario()"></button>
      <button pButton pRipple type="button" label="Agregar" class="p-button-raised p-button-text" icon="pi pi-plus"
        (click)="addUsuario()"></button>
    </div>
  </div>
</p-dialog>